import useSession from '@/hooks/useSession';
import styles from './threads-list.module.scss';
import { NavLink } from 'react-router-dom';
import LoadingSpinner from '@/components/LoadingSpinner';

const ThreadsList = () => {
  const { session, pushUserEvent } = useSession();
  return (
    <ul className={styles['threads-list']}>
      {session.threads.length > 0 && (
        <>
          {session.threads.map(({ items, id, processingStatus, title }, i) => {
            const lastMessage = items[items.length - 1];

            return (
              <li key={i}>
                <NavLink
                  data-testid="thread-list-item"
                  data-id={id}
                  title={title}
                  data-processing={typeof processingStatus !== 'undefined'}
                  to={`/thread/${id}`}
                  onClick={() => {
                    pushUserEvent('click_thread');
                  }}
                >
                  <div>
                    {processingStatus && (
                      <LoadingSpinner className={styles['processing-icon']} />
                    )}
                    <p>{title}</p>
                  </div>
                  {lastMessage && (
                    <span>
                      Last:{'  '}
                      {lastMessage.queryDate.toLocaleString()}
                    </span>
                  )}
                </NavLink>
              </li>
            );
          })}
        </>
      )}
    </ul>
  );
};

export default ThreadsList;
